import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'antd';
import styles from './SearchRecommendations.module.scss';
import Link from 'next/link';
import { Caption } from 'src/modules/search/components/caption/Caption';
import ScrollBound from 'react-scroll-bound';
import classnames from 'classnames';
import {
  ProductCategoryEntity,
  ProductCategoryLocalizedEntity,
  ProductEntity,
  ProductLocalizedEntity,
} from 'src/modules/products';
import { useLocale } from 'src/modules/locale';
import { getProductDetailsURL, getProductName } from 'src/modules/products/utils/products';
// import { getProductName } from 'src/modules/products/utils/productName';

export interface SearchRecommendationsProps {
  className?: string;
  topSearchedProducts: ProductEntity[];
  topSearchedProductCategories: ProductCategoryEntity[];
}

export const SearchRecommendations: FC<SearchRecommendationsProps> = ({
  className,
  topSearchedProducts,
  topSearchedProductCategories,
}) => {
  const t = useIntl();
  const { getLocalizedObject } = useLocale();

  return (
    <ScrollBound className={classnames(styles.container, className)} tagName="div">
      <Row>
        <Col className={styles.topResultsContainer} md={12} xs={24}>
          <Caption>{t.formatMessage({ id: 'search/top_product_searches_label' })}</Caption>
          {topSearchedProducts.map((p) => {
            const localizedProduct = getLocalizedObject<ProductLocalizedEntity>(p);

            return (
              <Link key={p.id} href={getProductDetailsURL(p)}>
                <a className={styles.link}>
                  <h4>{getProductName(localizedProduct)}</h4>
                </a>
              </Link>
            );
          })}
        </Col>
        <Col className={styles.topResultsContainer} md={12} xs={24}>
          <Caption>{t.formatMessage({ id: 'search/top_categories_label' })}</Caption>
          {topSearchedProductCategories.map((c) => {
            const localizedProductCategory = getLocalizedObject<ProductCategoryLocalizedEntity>(c);
            return (
              <Link href={`/products/${c.slug}`} key={c.id}>
                <a className={styles.link}>
                  <h4>{localizedProductCategory.name}</h4>
                </a>
              </Link>
            );
          })}
        </Col>
      </Row>
    </ScrollBound>
  );
};
